import { createSlice } from "@reduxjs/toolkit";

// Initial state
// Intial state: Temp isFulfilled, isPending, isRejected property are not must be used.

// Menu: label (mm = main menu, s = search, d = document, r = register)
const initialState = {
  list: [],
  cunstructor: [],
  mainmenu: [],
  datalistmenu: { _id: "alm_1", label: "alm_mm", name: "Main Menu" },
  subMenu: {
    mainMenu: { isOpenId: "" },
    subMainMenu: { isOpenId: "" },
    transMittalMenu: { isOpenId: "" },
    corresspondenceMenu: { isOpenId: "" },
  },
  // note: develop
  navigateData: {},
  isDrawerOpen: false,
  selectedMenu: {
    menu_id: "",
    sub_menu_id: "",
  },
  isDashboardDrawerOpened: true,
  isComponentDrawerOpened: true,
};

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setListMenu: (state, action) => {
      return {
        ...state,
        list: action.payload.list,
      };
    },
    setContructor: (state, action) => {
      return {
        ...state,
        cunstructor: action.payload.cunstructor,
      };
    },
    setDashboardDrawerOpened: (state, action) => {
      // Redux Toolkit menggunakan Immer, jadi kita bisa "memutasi" state seperti ini
      state.isDashboardDrawerOpened = action.payload;
    },
    setComponentDrawerOpened: (state, action) => {
      state.isComponentDrawerOpened = action.payload;
    },
    setMainMenu: (state, action) => {
      return {
        ...state,
        mainmenu: action.payload.mainmenu,
      };
    },
    setDataListMenu: (state, action) => {
      return {
        ...state,
        datalistmenu: action.payload.datalistmenu,
      };
    },
    setSubMenu: (state, action) => {
      return {
        ...state,
        subMenu: action.payload,
      };
    },
    setDrawerOpen: (state, action) => {
      return {
        ...state,
        isDrawerOpen: action.payload,
      };
    },
    setNavigate: (state, action) => {
      return {
        ...state,
        navigateData: action.payload,
      };
    },
    setSelectMenu: (state, action) => {
      return {
        ...state,
        selectedMenu: action.payload,
      };
    },
    setClearNavigate: (state, _) => {
      return {
        ...state,
        navigateData: {
          _id: "",
          icon: "",
          label: "",
          name: "",
          sub_menu: "",
        },
      };
    },
    setClearAllMenuState: (state, _) => {
      return {
        ...state,
        list: [],
        cunstructor: [],
        mainmenu: [],
        datalistmenu: { _id: "alm_1", label: "alm_mm", name: "Main Menu" },
        subMenu: {
          mainMenu: { isOpenId: "" },
          subMainMenu: { isOpenId: "" },
          transMittalMenu: { isOpenId: "" },
          corresspondenceMenu: { isOpenId: "" },
        },
        isDrawerOpen: false,
        navigateData: {
          _id: "",
          icon: "",
          label: "",
          name: "",
          sub_menu: "",
        },
        selectedMenu: {
          menu_id: "",
          sub_menu_id: "",
        },
      };
    },
  },
});

export const menuAction = {
  ...menuSlice.actions,
};

// Helper functions to access parts of state
// menu : It's got by property of CombineSlice
export function selectListMenu(state) {
  return state?.menu?.list;
}

export function selectContructor(state) {
  return state?.menu?.contructor;
}

export function selectMainMenu(state) {
  return state?.menu?.mainmenu;
}

export function selectDataListMenu(state) {
  return state?.menu?.datalistmenu;
}

export function selectSubMenu(state) {
  return state?.menu?.subMenu;
}

// note: develop
export function selectDrawerOpen(state) {
  return state?.menu?.isDrawerOpen;
}

export function selectNavigate(state) {
  return state?.menu?.navigateData;
}

export function selectMenu(state) {
  return state?.menu?.selectedMenu;
}

export default menuSlice.reducer;
